import GusService from '@services/gus';
import { useQuery } from '@tanstack/react-query';

export const useFetchTenant = (tenantId: string) =>
  useQuery({
    queryKey: ['get-tenant'],
    queryFn: () => GusService.getTenant(tenantId),
    enabled: !!tenantId,
  });
